/*
 * System Builder -- Product catalog structure
 * Prices and images are fetched live from Shopify on page load.
 * Dimensions sourced from product setup scripts.
 *
 * Treatment order (installation sequence):
 *   1. Sediment Filter
 *   2. Iron / Sulfur Filter
 *   3. Acid Neutralizer
 *   4. Water Softener
 *   5. Carbon Filter
 *   6. UV System
 *
 * Exception: when the raw water pH is below 6.0, the acid neutralizer
 * installs BEFORE the iron filter (air-injection iron filters need
 * corrected pH to oxidize iron). system-builder.js handles this swap
 * at runtime via the low-pH toggle.
 */
window.SystemBuilderData = {
  categories: [
    {
      id: 'sediment',
      order: 1,
      name: 'Sediment Filter',
      description: 'Catches dirt, sand, and particles before they reach your treatment systems.',
      installSteps: [
        'Shut off water supply and relieve pressure at a nearby faucet.',
        'Mount the Big Blue housing bracket to the wall after the pressure tank.',
        'Cut into the main line and plumb the housing inline using 3/4" or 1" fittings. Match the flow direction arrow on the housing.',
        'Install the 5-micron filter cartridge inside the housing.',
        'Turn water back on slowly. Check all connections for leaks.',
        'Run water for a few minutes to flush the new filter.'
      ],
      installNotes: 'No electricity or drain needed. Replace the cartridge every 6-12 months depending on sediment levels.',
      installTime: '30-60 minutes',
      defaultSizeIdx: 1,
      sizes: [
        {
          label: '10" Big Blue',
          bestFor: '1-2 bathrooms',
          widthIn: 6,
          depthIn: 6,
          heightIn: 15,
          handle: '10-inch-big-blue-sediment-filter-kit'
        },
        {
          label: '20" Big Blue',
          bestFor: '3+ bathrooms',
          widthIn: 7,
          depthIn: 7,
          heightIn: 22,
          handle: '20-inch-big-blue-sediment-filter-kit'
        }
      ]
    },
    {
      id: 'iron_filter',
      order: 2,
      name: 'Iron / Sulfur Filter',
      description: 'Removes iron, sulfur (rotten egg smell), and manganese from well water.',
      positionStepLowPh: 'Position the tank after the sediment filter and acid neutralizer. With raw pH below 6.0, the neutralizer must come first. Level the tank using the adjustable boot on the bottom.',
      installSteps: [
        'Position the tank after the sediment filter. Level it using the adjustable boot on the bottom.',
        'Load the Katalox Light media into the tank through the fill port using the included funnel. Do not drop media down the center riser tube.',
        'Attach the stainless steel bypass valve to the Fleck valve head.',
        'Plumb inlet (IN) and outlet (OUT) using 1" fittings. Use CPVC with solvent cement or PEX with SharkBite fittings.',
        'Run 1/2" drain tubing from the valve drain port to a floor drain, laundry tub, or waste pipe. Maintain an air gap at the discharge end.',
        'Plug the transformer into a standard 120V outlet (not on a light switch).',
        'Open the water valve slowly, 1/4 turn at a time. Flush for 10-15 minutes.',
        'Run a manual backwash cycle to settle the media and purge air.',
        'Set the time of day and backwash schedule on the valve.'
      ],
      installNotes: 'Do not open the water valve too fast during startup. A sudden rush of water shifts the media bed. The Vortech tank has a built-in distributor plate, so no gravel bed is needed.',
      installTime: '2-3 hours',
      defaultSizeIdx: 1,
      sizes: [
        {
          label: '1.5 cu ft',
          bestFor: '2-3 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 62,
          handle: 'iron-and-sulfur-filter-2510aio-fleck-1-5-cubic-foot-10-54-with-katalox-light'
        },
        {
          label: '2.0 cu ft',
          bestFor: '3-4 people',
          tankDiaIn: 12,
          depthIn: 14,
          heightIn: 60,
          handle: 'iron-and-sulfur-filter-fleck-2510aio-2-0-cubic-foot-12-52-with-katalox-light'
        },
        {
          label: '2.5 cu ft',
          bestFor: '4-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 63,
          handle: 'iron-removal-filter-fleck-2510aio-2-5-cubic-foot-13-54-with-katalox-light'
        }
      ]
    },
    {
      id: 'acid_neutralizer',
      order: 3,
      name: 'Acid Neutralizer',
      description: 'Raises low pH to protect pipes, fixtures, and appliances from corrosion.',
      canBackwash: true,
      positionStepLowPh: 'Position the tank after the sediment filter and BEFORE the iron filter. With raw pH below 6.0, the water must be neutralized first so the iron filter can do its job. Level the tank using the boot.',
      installSteps: [
        'Position the tank after the sediment filter and iron filter, and before any softener. Level it using the boot.',
        'Pour calcite media into the tank through the fill port using the included funnel. If Corosex/FloMag was included, mix 2-3 lbs per 50 lb bag of calcite before pouring. Fill to 10-12 inches from the top.',
        'Do not drop media down the center riser tube.',
        'Plumb inlet and outlet using 1" fittings (CPVC or PEX).',
        'Put the bypass in the service position. Open water slowly, 1/4 turn at a time.',
        'Flush for 10-15 minutes to rinse calcite dust.'
      ],
      installStepsBackwashing: [
        'Position the tank after the sediment filter and iron filter, and before any softener. Level it using the boot.',
        'Pour calcite media into the tank through the fill port using the included funnel. If Corosex/FloMag was included, mix 2-3 lbs per 50 lb bag of calcite before pouring. Fill to 10-12 inches from the top.',
        'Do not drop media down the center riser tube.',
        'Attach the bypass valve to the Fleck valve head.',
        'Plumb inlet (IN) and outlet (OUT) using 1" fittings.',
        'Run 1/2" drain tubing from the valve drain port to a floor drain, laundry tub, or waste pipe.',
        'Plug the transformer into a standard 120V outlet (not on a light switch).',
        'Open water slowly, 1/4 turn at a time. Flush for 10-15 minutes.',
        'Run a manual backwash cycle to settle the media and purge air.',
        'Set the time of day and backwash schedule on the valve.'
      ],
      installNotes: 'Non-backwashing units need no electricity or drain. Top up calcite every 6-12 months as the media dissolves (this is normal). Never use Corosex by itself without mixing it with calcite.',
      installNotesBackwashing: 'Backwashing models require a 120V outlet and drain line. Top up calcite every 6-12 months. If you have multiple backwashing systems, stagger the regeneration times (e.g. 2 AM and 4 AM).',
      installTime: '1.5-2.5 hours',
      defaultSizeIdx: 3,
      defaultBackwashingSizeIdx: 2,
      sizes: [
        {
          label: '1.0 cu ft',
          bestFor: '1 person',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 48,
          handle: 'acid-neutralizer-non-backwashing-clack-1-0-cubic-foot-10-44-vortech-with-calcite'
        },
        {
          label: '1.5 cu ft',
          bestFor: '1-3 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 58,
          handle: 'acid-neutralizer-non-backwashing-clack-1-5-cubic-foot-10-54-vortech-with-calcite'
        },
        {
          label: '2.0 cu ft',
          bestFor: '2-4 people',
          tankDiaIn: 12,
          depthIn: 14,
          heightIn: 56,
          handle: 'acid-neutralizer-non-backwashing-clack-2-0-cubic-foot-12-52-vortech-with-calcite'
        },
        {
          label: '2.5 cu ft',
          bestFor: '4-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 62,
          handle: 'acid-neutralizer-non-backwashing-clack-2-5-cubic-foot-13-54-vortech-with-calcite'
        }
      ],
      backwashingSizes: [
        {
          label: '1.5 cu ft',
          bestFor: '1-3 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 62,
          handle: 'acid-neutralizer-backwashing-fleck-2510sxt-1-5-cubic-foot-10-54-vortech-with-calcite'
        },
        {
          label: '2.0 cu ft',
          bestFor: '2-4 people',
          tankDiaIn: 12,
          depthIn: 14,
          heightIn: 60,
          handle: 'acid-neutralizer-backwashing-fleck-2510sxt-2-0-cubic-foot-12-52-vortech-with-calcite'
        },
        {
          label: '2.5 cu ft',
          bestFor: '4-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 62,
          handle: 'acid-neutralizer-backwashing-fleck-2510sxt-2-5-cubic-foot-13-54-vortech-with-calcite'
        }
      ]
    },
    {
      id: 'water_softener',
      order: 4,
      name: 'Water Softener',
      description: 'Removes hardness minerals that cause scale buildup and dry skin.',
      installSteps: [
        'Position the resin tank and brine (salt) tank near each other, after any acid neutralizer or iron filter.',
        'Level the resin tank using the boot.',
        'Connect the brine tank overflow line and brine tubing to the valve head (typically pre-assembled).',
        'Attach the stainless steel bypass valve to the Fleck valve head.',
        'Plumb inlet (IN) and outlet (OUT) using 1" fittings.',
        'Run 1/2" drain tubing to a floor drain, laundry tub, or waste pipe. Regeneration uses 40-80 gallons, so make sure your drain can handle it.',
        'Plug the transformer into a standard 120V outlet (not on a light switch).',
        'Fill the brine tank about 1/3 to 1/2 full with salt.',
        'Open water slowly, 1/4 turn at a time. Flush for 10-15 minutes.',
        'Run a manual regeneration cycle. Confirm the water level in the brine tank drops during the cycle.',
        'Set the time of day, hardness level, and regeneration schedule on the valve.'
      ],
      installNotes: 'The resin ships in separate bags and is loaded into the tank at install; drain tubing is not included. Use about 40 lbs of salt per month. If your plumber has questions during install, call Aidan at 800-460-5810.',
      installTime: '3-4 hours',
      defaultSizeIdx: 1,
      hasBrineTank: true,
      brineTankWidthIn: 18,
      brineTankDepthIn: 18,
      brineTankHeightIn: 33,
      sizes: [
        {
          label: '32,000 grain',
          bestFor: '2-5 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 62,
          handle: 'water-softener-fleck-5600sxt-32000-grain-18-33-salt-tank'
        },
        {
          label: '48,000 grain',
          bestFor: '2-8 people',
          tankDiaIn: 12,
          depthIn: 14,
          heightIn: 56,
          handle: 'water-softener-fleck-5600sxt-48000-grain-18-33-salt-tank-with-10-crosslink-resin'
        },
        {
          label: '64,000 grain',
          bestFor: '2-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 62,
          handle: 'water-softener-fleck-5600sxt-64000-grain-18-33-salt-tank-with-10-crosslink-resin'
        }
      ]
    },
    {
      id: 'carbon_filter',
      order: 5,
      name: 'Carbon Filter',
      description: 'Removes chlorine, chemicals, and improves taste and odor.',
      canBackwash: true,
      installSteps: [
        'Position the tank after the iron filter and acid neutralizer. Level it using the boot.',
        'Load the carbon media into the Vortech tank through the fill port using the included funnel.',
        'Do not drop media down the center riser tube.',
        'Plumb inlet and outlet using 1" fittings (CPVC or PEX).',
        'Put the bypass in the service position. Open water slowly, 1/4 turn at a time.',
        'Flush for 10-15 minutes to rinse carbon fines.'
      ],
      installStepsBackwashing: [
        'Position the tank after the iron filter and acid neutralizer. Level it using the boot.',
        'Load the carbon media into the Vortech tank through the fill port using the included funnel.',
        'Do not drop media down the center riser tube.',
        'Attach the bypass valve to the Fleck valve head.',
        'Plumb inlet (IN) and outlet (OUT) using 1" fittings.',
        'Run 1/2" drain tubing from the valve drain port to a floor drain, laundry tub, or waste pipe.',
        'Plug the transformer into a standard 120V outlet (not on a light switch).',
        'Open water slowly, 1/4 turn at a time. Flush for 10-15 minutes.',
        'Run a manual backwash cycle to settle the media and purge air.',
        'Set the time of day and backwash schedule on the valve.'
      ],
      installNotes: 'Non-backwashing units need no electricity or drain. Replace the carbon media every 5 years.',
      installNotesBackwashing: 'Backwashing models require a 120V outlet and drain line. Replace the carbon media every 5 years. If you have multiple backwashing systems, stagger the regeneration times.',
      installTime: '2-3 hours',
      sizes: [
        {
          label: '1.5 cu ft',
          bestFor: '1-4 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 58,
          handle: 'carbon-filter-non-backwashing-clack-1-5-cubic-foot-10-54-vortech-with-activated-carbon'
        },
        {
          label: '2.5 cu ft',
          bestFor: '4-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 62,
          handle: 'carbon-filter-non-backwashing-clack-2-5-cubic-foot-13-54-vortech'
        }
      ],
      backwashingSizes: [
        {
          label: '1.5 cu ft',
          bestFor: '1-4 people',
          tankDiaIn: 10,
          depthIn: 12,
          heightIn: 62,
          handle: 'catalytic-carbon-filter-backwashing-fleck-2510sxt-1-5-cubic-foot-10-54-vortech'
        },
        {
          label: '2.5 cu ft',
          bestFor: '4-8 people',
          tankDiaIn: 13,
          depthIn: 15,
          heightIn: 62,
          handle: 'catalytic-carbon-filter-backwashing-fleck-2510sxt-2-5-cubic-foot-13-54-vortech'
        }
      ]
    },
    {
      id: 'uv_system',
      order: 6,
      name: 'UV Disinfection',
      description: 'Kills bacteria, viruses, and microorganisms with ultraviolet light.',
      installSteps: [
        'The UV system must be installed last, after all other treatment equipment. Water must be clean and clear before entering the UV chamber.',
        'Mount the UV chamber horizontally or vertically using the included brackets.',
        'Connect inlet and outlet to your plumbing using the chamber fittings (3/4" or 1" depending on model).',
        'Plug into a dedicated, always-on 120V outlet. This outlet should never be on a light switch.',
        'Turn on water and check all connections for leaks.',
        'Verify the UV lamp indicator light is on and glowing.',
        'Run water through the system for several minutes before using it for drinking.'
      ],
      installNotes: 'The UV lamp must be replaced once a year, even though it still glows. The lamp degrades over time and loses its disinfection power. The VH410 is longer than the VH200 (not wider), so plan your wall space accordingly.',
      installTime: '1-2 hours',
      sizes: [
        {
          label: 'Viqua VH200',
          bestFor: 'Up to 9 GPM',
          widthIn: 6,
          depthIn: 6,
          heightIn: 36,
          handle: 'ultraviolet-uv-water-disinfection-systems'
        },
        {
          label: 'Viqua VH410',
          bestFor: 'Up to 18 GPM',
          widthIn: 6,
          depthIn: 6,
          heightIn: 42,
          handle: 'viqua-vh410-uv-system'
        }
      ]
    }
  ],
  clearanceBetweenIn: 6,
  overheadClearanceIn: 6,
  wellTankHandle: 'well-x-trol-well-tanks-202-xtrol-pro-series'
};
